/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetPrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getPrivacyRequest = (request: GetPrivacyRequestRequest, options?: CashRequestOptions) => post<GetPrivacyRequestRequest, GetPrivacyRequestResponse>("/2.0/cash/get-privacy-request", request, {...options, rejectOnError: true })